export const ADOBE_COMMERCE = "aem-commerce";
export const CLASSROOM = "Classroom";
export const VIRTUAL_CLASSROOM = "Virtual Classroom";
export const ACTIVITY = "Activity";
export const ELEARNING = "Elearning";
export const PENDING_APPROVAL = "PENDING_APPROVAL";
export const PENDING_ACCEPTANCE = "PENDING_ACCEPTANCE";
export const WAITING = "WAITING";
export const STARTED = "STARTED";

export const SELF_ENROLL = "Self Enroll"

export const COURSE = "course";
export const CERTIFICATION = "certification";
export const PREWORK = "Pre Work";
export const TESTOUT = "Test Out";
export const CONTENT = "Content";
export const JOBAID = "jobAid";

export const REQUIRED_ERROR_MESSAGE = "Is required";
export const PREVIEW = "PREVIEW";
export const ENROLL = "ENROLL";
export const ADD_TO_CART = "ADD_TO_CART";
export const LEARNING_PROGRAM = "learningProgram";
export const TRAINING_ID_STR = "trainingId";
export const TRAINING_INSTANCE_ID_STR = "trainingInstanceId";
export const ENROLLED = "ENROLLED";
export const REJECTED = "REJECTED";
export const COMPLETED = "COMPLETED";
export const COMPLETED_IC = "Completed";
export const PENDING_SUBMISSION = "PENDING_SUBMISSION";
export const CHANGE = "CHANGE";
export const APPROVED = "APPROVED";
export const PUBLIC = "PUBLIC";
export const PRIVATE = "PRIVATE";
export const BOARD = "board";
export const HIGH = "HIGH";
export const NORMAL = "NORMAL";
export const DATE_UPDATED = "Date Updated";
export const DATE_CREATED = "Date Created";
export const SKILL_LEVEL = "skillLevel";
export const SKILL = "SKILL";
export const SKILL_LC = "skill";
export const UPVOTE = "UPVOTE";
export const DOWNVOTE = "DOWNVOTE";
export const COMMENT = "comment";
export const REPLY = "reply";
export const POST = "post";
export const UP = "UP";
export const DOWN = "DOWN";
export const ENTER = "Enter";
export const QUESTION = "QUESTION";
export const POLL = "POLL";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const VIDEO = "VIDEO";
export const AUDIO = "AUDIO";
export const IMAGE = "IMAGE";
export const HEADLINE = "HEADLINE";
export const DESCRIPTION = "DESCRIPTION";
export const TILE_VIEW = "TILE_VIEW";
export const LIST_VIEW = "LIST_VIEW";
export const HOME = "home";
export const CATALOG = "catalog";

export const USERS_SUGGESTIONS = "USERSSUGGESTIONS";
export const POPULAR_SUGGESTIONS = "POPULARSSUGGESTIONS";

export const ENGLISH_LOCALE = "en-US";
export const MANAGER_APPROVAL = "Manager Approval";
export const RETIRED = "Retired";

export const PR = "PR";
export const CP = "CP";
export const PDF = "PDF";
export const DOC = "DOC";
export const PPT = "PPT";
export const XLS = "XLS";

export const SKILLS = "skills";
export const FOLLOW = "follow";
export const LEADERBOARD = "leaderboard";
export const FAVOURITES = "favs";
export const ANNOUNCEMENT="announcement";
export const MYBOARDS = "MyBoards"

export const FLEX_LP_COURSE_INFO = "flexLPCourseInfo";
export const DEFAULT_THEME = "Default";
export const CARNIVAL_THEME = "Carnival";
export const WINTER_SKY_THEME = "Winter Sky";
export const VIVID_THEME = "Vivid";
export const PEBBLES_THEME = "Pebbles";
export const AUTUMN_THEME = "Autumn";

export const CHECKLIST = "CHECKLIST";
export const PENDING = "PENDING";
export const PASSED = "passed";
export const FAILED = "failed"